/* eslint-disable @typescript-eslint/no-unused-vars */
import { ActivityInterface, WorkflowStepInterface } from '@vendasta/automata';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ActivityTableEntry, AutomationDisplayService, NodeData } from '../../common/automation-display.service';
import { Injectable } from '@angular/core';
import { AutomationErrorHandlerService, StringFormattingService } from '../../../services';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class InitPartnerSubscriptionUpdateService extends AutomationDisplayService {
  constructor(
    protected readonly formatter: StringFormattingService,
    protected readonly translateService: TranslateService,
    protected readonly sanitizer: DomSanitizer,
    protected readonly errorHandler: AutomationErrorHandlerService,
  ) {
    super();
  }

  getAutomationNodeData(
    _namespace: string,
    _step: WorkflowStepInterface,
    _isWaitUntilNode: boolean,
  ): Observable<NodeData> {
    // Node display data contains the text to display as well as validation errors.
    // Validation errors appear when the node is rendered.
    return this.nodeDisplayData(
      this.translateService.stream('AUTOMATIONS.EDITOR.TRIGGERS.INIT_SUBSCRIPTION_TIER_UPDATE.WHEN_ACTION'),
      this.noValidationErrorsDetected(),
    );
  }

  getActivityColumn(_namespace: string, _activity: ActivityInterface): ActivityTableEntry {
    // A convenience method that provides a table entry with the standard trigger title.
    return this.triggerActivityEntry(
      this.translateService.stream('AUTOMATIONS.EDITOR.TRIGGERS.INIT_SUBSCRIPTION_TIER_UPDATE.ACTIVITY'),
    );
  }
}
